const isDesktop = () => Odigeo.SessionScope.flow === 'desktop';

module.exports = isDesktop() ? require('./config.desktop') : require('./config.mobile');
